<div class="dealer-need-service">
  <!-- START SERVICE CARD-->
  <!-- Alert will go here -->
  <div class="alert alert-success alert-dismissable" *ngIf="cancelAppointmentSuccess">
    <!--All of the following should be in CMS and used with *ngIf and translate -->
    <div class="panel-body-alert success">
      <p class="gb-headline3" role="heading" aria-level="3" [translate]="'upcoming_service_cancel_success_title'"></p>
      <p class="gb-body1" [translate]="'upcoming_service_cancel_success_text'"></p>
    </div>
  </div>
  <div class="alert alert-danger alert-dismissable" *ngIf="cancelAppointmentFail">
    <!--All of the following should be in CMS and used with *ngIf and translate -->
    <div class="panel-body-alert danger">
      <p class="gb-body1" [translate]="'upcoming_service_cancel_failure_text'"></p>
    </div>
  </div>
  <div class="card card-default">

    <!-- start primary card -->
    <div class="border-bottom">
      <ng-container [ngTemplateOutlet]="header"></ng-container>
    </div>
    <!-- Switch between states guestMode, upcomingService, confirmCancel, hasPreferred, noPreferred, and cannotLoad -->
    <div class="gmWidgetPanel" [ngSwitch]="widget.state">
      <!-- Display Spinner while loading -->
      <ng-container [ngTemplateOutlet]="loading" *ngSwitchCase="'loading'"></ng-container>

      <!-- Display preferred dealer content unless "noPreferredDealer" is true -->
      <ng-container [ngTemplateOutlet]="hasPreferred" *ngSwitchCase="'hasPreferred'"></ng-container>

      <!-- Encourage user to choose preferred dealer if "noPreferredDealer" is true -->
      <ng-container [ngTemplateOutlet]="noPreferred" *ngSwitchCase="'noPreferred'"></ng-container>

      <!-- Display only when a VIN in the Garage has scheduled service and  only when logged in -->
      <ng-container [ngTemplateOutlet]="upcomingService" *ngSwitchCase="'upcomingService'"></ng-container>

      <!-- Display option of confirm to cancel or keep service scheduled -->
      <ng-container [ngTemplateOutlet]="confirmCnx" *ngSwitchCase="'confirmCancel'"></ng-container>

      <!-- Display Guest Mode if not logged in "guestMode" is true -->
      <ng-container [ngTemplateOutlet]="guestMode" *ngSwitchCase="'unauthenticated'"></ng-container>

      <!-- Display Server Error if "cannotLoad" is true -->
      <ng-container [ngTemplateOutlet]="cannotLoad" *ngSwitchCase="'cannotLoad'"></ng-container>
    </div>
  </div>
</div>

<ng-template #header>
    <span oc-widget-header="Exp" collapsible="true">
            <div [ngSwitch]="widget.state">
                <div *ngSwitchCase="'upcomingService'|| 'confirmCancel'">
                    <div class="gb-headline2 card-title" role="heading" aria-level="2"
                         [translate]="'upcoming_service_title'"></div>
                </div>
                <div *ngSwitchDefault>
                    <span class="gb-headline2 card-title" role="heading" aria-level="2"
                          [translate]="'preferredDealerWidget_widgetTitle'"></span>
                </div>
            </div>
        </span>
</ng-template>

<ng-template #loading>
  <ox-loading></ox-loading>
</ng-template>

<ng-template #hasPreferred>
  <div class="card-contents">
    <div class="card-body">
      <!-- start card content -->
      <div class="gb-headline3 mb-2">
        <span [translate]="'preferredDealerWidget_header'"></span>

      </div>
      <div class="margin-bottom-medium">
        <webu-compact-dealer-info
          [dealer]="widget.dealer"
          [userAddress]="userAddress"
          [trackLink]="'Need Service:Dealer Phone'"
          [trackDelay]="'true'"
          [trackType]="'o'"
          [prop10]="'need service:link:phone number'">
        </webu-compact-dealer-info>
      </div>
      <ul class="mb-0 language">
        <li>
            <span class="gb-body2" [trackLink]="'Need Service:View Dealer Info'" [trackDelay]="'true'"
                  [trackType]="'o'" [prop10]="'need service:link:view dealer info'">
                <a class="no-href" id="viewDealerInfo" (click)="showPreferrdDealer()"
                  (keyup.enter)="showPreferrdDealer()"
                  trackLink="'need service:l∂ink:find a dealer'"
                  prop10="'need service:l∂ink:find a dealer'"
                  evar33="'need service:link:find a dealer'"
                  trackEvent="'event303'"
                  aria-haspopup="dialog"
                  aria-expanded="isAriaExpanded"
                  tabindex="0">
                    <span aria-hidden="true" class="icon-ui-view"></span>&nbsp;
                    <span [translate]="'preferredDealerWidget_viewDealerBtn_text'"></span>
                    <ox-drawer-modal
                      [(show)]="showPreferredDealer"
                      [bodyComponent]="preferredDealer"
                      [options]='{ ignoreBackdropClick: false, keyboard: false, id: "myModal"}'
                      [bindingInputs]="pdInputs"
                      [bindingOutputs]="pdOutputs">
                    </ox-drawer-modal>
                </a>
            </span>
          </li>
        <li *ngIf="!hideScheduleServiceLink">
            <span class="gb-body2" [trackLink]="'Need Service:Schedule Service'" [trackDelay]="'this'"
                  [trackType]="'e'" [prop10]="'need service:button:schedule service'"
                  [evar33]="'need service:button:schedule service'" [trackEvent]="'event303'">
                <!-- TODO: fix ng-href -- getScheduleServiceUrl doesn't exist for DealershipService-->
                <a class="no-href" (click)="getScheduleService()" (keyup.enter)="getScheduleService()" target="_self" tabindex="0" >
                    <span class="icon-graphic-service"></span>&nbsp;
                    <span [translate]="'preferredDealerWidget_scheduleServiceBtn_text'"></span>
                </a>
            </span>
        </li>

        <li *ngIf="widget.driverType === 'isDefaultDriver'">
            <span class="gb-body2" [trackLink]="'Need Service:Find A Dealer'" [trackDelay]="'true'"
                  [trackType]="'o'" [prop10]="'need service:link:find a dealer'">
                <a class="no-href" id="findAnotherDealer" (click)="showLocateDealer()" (keyup.enter)="showLocateDealer()"
                   trackLink="'need service:link:find a dealer'"
                   prop10="'need service:link:find a dealer'"
                   evar33="'need service:link:find a dealer'"
                   trackEvent="'event303'"
                   aria-haspopup="dialog" aria-expanded="false" tabindex="0">
                    <span aria-hidden="true" class="icon-ui-search"></span>&nbsp;
                    <span [translate]="'preferredDealerWidget_findDealerBtn_text'"></span>
                </a>
            </span>
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #noPreferred>
  <div class="card-contents">
    <div class="card-body">
      <span class="gb-body1 mb-6" [translate]="'preferredDealerWidget_noDealer_message'"></span>
      <ul class="mb-0 language">
        <li>
            <span [trackLink]="'Need Service:Find A Dealer'"
                  [trackDelay]="'true'" [trackType]="'o'"
                  [prop10]="'need service:link:find a dealer'">
                <button class="gb-primary-button-inline-icon icon-left" (click)="showLocateDealer()">
                    <span aria-hidden="true" class="icon-ui-search"></span>&nbsp;
                    <span [translate]="'preferredDealerWidget_noDealer_findDealerBtn_text'"></span>
                </button>
            </span>
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #upcomingService>
  <div class="panel-contents">
    <ul class="mb-0">
      <li class="mb-0"
          *ngFor="let activeVinAppt of activeVinAppts ; ">
        <div class="panel-body border-bottom">
          <div class="gb-headline3 mb-0">
            <div class="gb-headline3" role="heading" aria-level="3" [translate]="'upcoming_service_date'"></div>
          </div>
          <div class="gb-body1 margin-bottom-small" translate="{{activeVinAppt.month}}"
               [translateParams]="{day:activeVinAppt.day, year:activeVinAppt.year, time:activeVinAppt.serviceLaneVisit.appointmentTime.start}">
          </div>
          <div class="gb-headline3 mb-0">
            <div class="gb-headline3" role="heading" aria-level="3"
                 [translate]="'upcoming_service_description'"></div>
          </div>
          <ul class="gb-body1 margin-bottom-small">
            <li class="mb-0"
                *ngFor="let lineItem of activeVinAppt.serviceLaneVisit.lineItems">
              {{lineItem.name}}
            </li>
          </ul>
          <div class="mb-0">
            <div class="gb-headline3" role="heading" aria-level="3" [translate]="'upcoming_service_dealership'">
            </div>
            <div class="dealer-info-compact">
              <ul class="gb-body1 margin-bottom-small">
                <li class="heavy mb-0">
                  {{activeVinAppt.dealership.name}}
                </li>
                <li class="mb-0">
                  {{activeVinAppt.dealership.address.addressLine1}}
                </li>
                <li class="mb-0">
                  {{activeVinAppt.dealership.address.cityName}},
                  {{activeVinAppt.dealership.address.countrySubentity}}
                  {{activeVinAppt.dealership.address.postalZone}}</li>
                <li>
                  <a id="telephoneNumber1"
                     tabindex="0"
                     class="noBold noWrap"
                     href="tel:+{{activeVinAppt.dealership.departments[0].phoneNumber}}">
                    <u>{{activeVinAppt.dealership.departments[0].phoneNumber}}
                    </u>
                  </a>
                </li>
              </ul>
            </div>
            <div class="gb-body1">
              <a class="#" tabindex="0" [translate]="'upcoming_service_modify'"
                 (click)="changeThis(activeVinAppt.serviceLaneVisit)" (keyup.enter)="changeThis(activeVinAppt.serviceLaneVisit)"></a>
            </div>
            <div class="gb-body1">
              <a class="#" tabindex="0" [translate]="'upcoming_service_cancel'" (click)="cancelThis(activeVinAppt)" (keyup.enter)="cancelThis(activeVinAppt)"></a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="panel-body border-bottom row mx-0" *ngIf="activeVinAppts.length > 1">
      <div class="col-6 gb-body1 textLeft px-0" *ngIf="!allActiveAppts"
           [translate]="'total_appointments'"
           [translateParams]="{showing:repeat, total:activeVinAppts.length}"></div>
      <div class="col-6 gb-body1 textRight" *ngIf="allActiveAppts">
        <a id="showAllButton" (click)="toggle('showall')" [translate]="'show_all'"
           class="#"></a>
      </div>
      <div class="col-6 gb-body1 textLeft" *ngIf="allActiveAppts"
           [translate]="'total_appointments'"
           [translateParams]="{showing:repeat, total:activeVinAppts.length}"></div>
      <div class="col-6 gb-body1 textRight" *ngIf="allActiveAppts">
        <a (click)="toggle('showless')" [translate]="'show_less'" class="#"></a>
      </div>
    </div>
    <div class="panel-body" *ngIf="!hideScheduleServiceLink">
      <div class="gb-headline3" role="heading" aria-level="3"
           [translate]="'upcoming_service_addAppointment'"></div>
      <span class="gb-body1"
            [trackLink]="'Need Service:Schedule Service'"
            trackDelay="this"
            trackType="e"
            prop10="need service:button:schedule service"
            evar33="need service:button:schedule service"
            trackEvent="event303">
          <a (click)="getScheduleService()" (keyup.enter)="getScheduleService()"
             target="_self" tabindex="0" class="#">
              <span class="icon-graphic-service"></span>&nbsp;
              <span [translate]="'upcoming_service_addAppointment_btn'"></span>
          </a>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #confirmCnx>
  <div class="panel-contents">
    <div class="panel-body">
      <div class="gb-body1">
        <span [translate]="'upcoming_service_cancel_confirmation_text'"></span>
        <span [translate]="cancelThisAppt.month"
              [translateParams]="{ day: cancelThisAppt.day, year: cancelThisAppt.year, time: '' }"></span>
        <span [translate]="'upcoming_service_cancel_confirmation_text_end'"
              [translateParams]="{ day: '', year: '', specified_dealership: cancelThisAppt.dealership.name }"></span>
      </div>
      <ul class="mb-0">
        <li class="margin-bottom-small">
          <button class="gb-secondary-button" prop10="'need service:link:cancel appointment:yes'"
                  trackLink="'need service:link:cancel appointment:yes'"
                  evar33="'need service:link:cancel appointment:yes'"
                  trackEvent="'event303'"
                  [translate]="'upcoming_service_cancel_confirmation_yes'"
                  (click)="confirmCancel()"></button>
        </li>
        <li>
          <button class="gb-primary-button"
                  trackLink="'need service:link:cancel appointment:no'"
                  prop10="'need service:link:cancel appointment:no'"
                  evar33="'need service:link:cancel appointment:no'"
                  trackEvent="'event303'"
                  [translate]="'upcoming_service_cancel_confirmation_no'"
                  (click)="changeState('noCancel')"></button>
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #guestMode>
  <div class="card-contents">
    <div class="card-body">
      <div class="margin-bottom-medium">
        <p class="gb-body1" [translate]="'preferredDealerWidget_guestMode_findMessage'"></p>
        <button class="gb-primary-button-inline-icon icon-left language px-2"
                id="locateDealerGuestMode"
                (click)="showLocateDealer()"
                [trackLink]="'Need Service:Unauth:Find A Dealer'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [prop10]="'need service:link:find a dealer'"
                [evar33]="'need service:link:find a dealer'"
                [prop51]="prop51??''"
                [trackEvent]="'event303'"
                aria-haspopup="dialog"
                aria-expanded="false">
          <span aria-hidden="true" class="icon-ui-search"></span>&nbsp;
          <span [translate]="'preferredDealerWidget_noDealer_findDealerBtn_text'"></span>&nbsp;
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cannotLoad>
  <div class="card-contents">
    <div class="card-body">
      <!-- start card content -->
      <ul class="mb-0">
        <li>
          <p ox-alert type="error">
                <span role="alert" aria-atomic="true" [translate]="'preferredDealer_cannotLoad'"
                      class="gb-body1"></span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<ox-drawer-modal
  [(show)]="showDealerLocator"
  [bodyComponent]="locateDealer"
  [bindingInputs]="{prop44, prop53}"
  [options]='{ ignoreBackdropClick: false, keyboard: false, id: "myModal"}'>
</ox-drawer-modal>
